<template>

    <div class="validationMarkersContainer">

<!--        <a class="btn btn-primary btn-sm text-white float-right mb-2" @click="requestValidation"><i class="fa fa-check"></i>  {{$t('text.signatureValidation.checkSignatureValidity1')}} <span v-if="numberOfSignatures === 1">{{$t('text.signatureValidation.checkSignatureValidity2')}}</span><span v-if="numberOfSignatures > 1">{{$t('text.signatureValidation.checkSignatureValidity3')}}</span></a>-->

        <b-modal
                centered
                size="lg"
                ref="signature-data-modal"
                :title="$t('text.signatureValidation.signatureInformation')">


            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="false"></loading>


            <div class="row" v-if="certificateValidation.length === 0 && !isLoading">

                <div class="col-md-12">
                    <em class="text-muted"><i class="fa fa-exclamation-triangle mr-2"></i> {{$t('text.signatureValidation.certificateNotSigned')}}</em>
                </div>
            </div>

            <div class="row" v-if="certificateValidation.length === 0 && isLoading">
                <div class="col-md-12" style="min-height: 120px">
                    <em class="text-muted"><i class="fa fa-circle-notch fa-spin mr-2"></i> {{$t('text.signatureValidation.certificateSignatureValidityCheckInProgress')}} ...</em>
                </div>
            </div>

            <div class="row" v-if="certificateValidation.length > 0">

                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-12">
                            <h6><strong>{{$t('text.signatureValidation.eIDASValidation')}}</strong></h6>
                            <div class="signatureCompareScrollableColumn">
                                <div class="card mb-2" v-for="(item, index) in certificateValidation" :key="'ehramba_podpis_eidas' + index">
                                    <div class="signatureValidationResultsDetailsInModal card-body">

                                        <div class="signatureNumbering badge badge-info px-2">{{$t('text.signatureValidation.result')}} #{{index+1}}</div>

                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.signatureType')}}</dt>
                                            <dd class="col-sm-12">{{item.signatureType ? item.signatureType : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.validityWitheIDAS')}}</dt>
                                            <dd class="col-sm-12">{{item.validByEidas ? getReadableBoolean(item.validByEidas) : '/'}}
                                            </dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.signatureValidity')}}</dt>
                                            <dd class="col-sm-12">{{getReadableResult(item.valid)}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.signeeNameAndSurname')}}</dt>
                                            <dd class="col-sm-12 text-break">{{item.certCn ? item.certCn : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.signatureTime')}}</dt>
                                            <dd class="col-sm-12 text-break">{{item.certSignatureTime ? moment.utc(item.certSignatureTime, 'DD.MM.YYYY HH:mm:ss').local().format('DD. MM. YYYY HH:mm:ss') : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.timestampInfo')}}</dt>
                                            <dd class="col-sm-12 text-break">{{item.timestampInfo ? item.timestampInfo : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.certificateIssuer')}}</dt>
                                            <dd class="col-sm-12 text-break">{{item.certCa ? item.certCa : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.certificateSerial')}}</dt>
                                            <dd class="col-sm-12 text-break">{{item.certSerial ? item.certSerial : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.validFrom')}}</dt>
                                            <dd class="col-sm-12 text-break">{{item.validFrom ? moment.utc(item.validFrom, 'DD.MM.YYYY HH:mm:ss').local().format('DD. MM. YYYY HH:mm:ss') : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.validTo')}}</dt>
                                            <dd class="col-sm-12 text-break">{{item.validTo ? moment.utc(item.validTo, 'DD.MM.YYYY HH:mm:ss').local().format('DD. MM. YYYY HH:mm:ss') : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.validationCheckTime')}}</dt>
                                            <dd class="col-sm-12 text-break">{{item.validationTime ? moment.utc(item.validationTime, 'DD.MM.YYYY HH:mm:ss').local().format('DD. MM. YYYY HH:mm:ss') : '/'}}</dd>
                                        </dl>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-12">
                            <h6><strong>{{$t('text.signatureValidation.signatureInfoFromMetadata')}}</strong></h6>

                            <div class="signatureCompareScrollableColumn">
                                <div class="card bg-light" v-for="(item, index) in ehrambaSignatureData"
                                     :key="'ehramba_podpis_metadata' + index">
                                    <div class="signatureValidationResultsDetailsInModal card-body">

                                        <div class="signatureNumbering badge badge-info px-2">{{$t('text.signatureValidation.signature')}} #{{index+1}}</div>

                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.signatureType')}}</dt>
                                            <dd class="col-sm-12">/</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.validityWitheIDAS')}}</dt>
                                            <dd class="col-sm-12">/</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.signatureValidity')}}</dt>
                                            <dd class="col-sm-12 text-break">{{$globalFunctions.getReadableCodeListValueFromProperty($store.getters.getAllMetadataOptions, 'EH:oznaka_da_je_podpis_veljaven_neveljaven', ehrambaSignatureData[index]['EH:oznaka_da_je_podpis_veljaven_neveljaven'])}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.signeeNameAndSurname')}}</dt>
                                            <dd class="col-sm-12 text-break">{{ehrambaSignatureData[index]['EH:ime_in_priimek_podpisnika']}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.signatureTime')}}</dt>
                                            <dd class="col-sm-12 text-break">{{ehrambaSignatureData[index]['EH:datum_in_ura_podpisa'] ? moment(ehrambaSignatureData[index]['EH:datum_in_ura_podpisa']).utc().format("DD. MM. YYYY HH:mm:ss") : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.timestampInfo')}}</dt>
                                            <dd class="col-sm-12 text-break">{{ehrambaSignatureData[index]['EH:casovni_zig'] ? moment(ehrambaSignatureData[index]['EH:casovni_zig']).utc().format("DD. MM. YYYY HH:mm:ss") : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.certificateIssuer')}}</dt>
                                            <dd class="col-sm-12">{{ehrambaSignatureData[index]['EH:izdajatelj_certifikata']}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.certificateSerial')}}</dt>
                                            <dd class="col-sm-12 text-break">{{ehrambaSignatureData[index]['EH:stevilka_certifikata']}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.validFrom')}}</dt>
                                            <dd class="col-sm-12 text-break">{{ehrambaSignatureData[index]['EH:velja_od'] ? moment(ehrambaSignatureData[index]['EH:velja_od']).utc().format("DD. MM. YYYY HH:mm:ss") : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.validTo')}}</dt>
                                            <dd class="col-sm-12 text-break">{{ehrambaSignatureData[index]['EH:velja_do'] ? moment(ehrambaSignatureData[index]['EH:velja_do']).utc().format("DD. MM. YYYY HH:mm:ss") : '/'}}</dd>
                                        </dl>
                                        <dl class="row">
                                            <dt class="col-sm-12">{{$t('text.signatureValidation.validationCheckTime')}}</dt>
                                            <dd class="col-sm-12 text-break">
                                              {{ehrambaSignatureData[index]['EH:cas_preverjanja_elektronskega_podpisa'] ? moment(ehrambaSignatureData[index]['EH:cas_preverjanja_elektronskega_podpisa']).utc().format("DD. MM. YYYY HH:mm:ss") : '/'}}
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div slot="modal-footer" class="w-100">
                <b-button
                        variant="secondary"
                        class="float-left"
                        @click="$refs['signature-data-modal'].hide()">
                    {{$t('text.globals.close')}}
                </b-button>
            </div>

        </b-modal>
    </div>


</template>

<script>
    import Vue from 'vue';
    import axios from 'axios/index';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'signatureValidation',
        props: ['uuid', 'numberOfSignatures', 'ehrambaSignatureData'],
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
                certificateValidation: []

            }
        },
        mounted() {
            const _this = this;

        },
        methods: {
            showCertificateValidationModal() {
                const _this = this;

                _this.$refs['signature-data-modal'].show();
            },
            closeModal() {
                const _this = this;

                if (_this.$refs['signature-data-modal']) {
                    _this.$refs['signature-data-modal'].hide();
                }
            },

            requestValidation() {
                const _this = this;

                _this.showCertificateValidationModal();
                _this.isLoading = true;

                let formData = new FormData();
                formData.append("nodeId", this.uuid);


                axios.post(config.rootEhramba + 'signatureValidation', formData)
                    .then((res) => {
                        _this.certificateValidation = res.data.data;
                        _this.isLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        _this.closeModal();
                        _this.isLoading = false;
                    });
            },

            getReadableResult(result) {
                if (result.toString().toLowerCase() === 'true') {
                    return this.$t('text.signatureValidation.getReadableResult.valid');
                } else if (result.toString().toLowerCase() === 'false') {
                    return this.$t('text.signatureValidation.getReadableResult.invalid');
                } else {
                    return this.$t('text.signatureValidation.getReadableResult.unknown');
                }
            },

            getReadableBoolean(booleanValue) {
                booleanValue = booleanValue.toString().toLowerCase();
                if (booleanValue === 'true') {
                    return this.$t('text.globals.yes');
                } else if (booleanValue === 'false') {
                    return this.$t('text.globals.no');
                } else {
                    return this.$t('text.getReadableBoolean.unknown');
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/SignatureValidation.vue